import GapsDescriptionTable from './GapsDescriptionTable';

export default GapsDescriptionTable;
